<template>
    <div>
        <htmlHeader :top_index="2" :menuCode="false" :crumbsShow="false" />
        <div class="div">
            <img src="../assets/dingzhi/brand2.png" alt="" style="width:100%;">
            <p style="height: 14px;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;line-height: 16px;text-align: center;margin:20px 0 0 0">科隆人秉承“永远寻求用创新方法解决行业未解决问题”的精神，推动着行业高端定制的发展；全面配合定制客户，研究开发新产品、新技术、新工艺、新标准。</p>
            <div style="margin:auto">
               <div style="margin:112px 0 41px 0" >
                    <span style="width: 268px;height: 29px;font-size: 30px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;line-height: 48px;" class="biaoti">定制研发</span>
                    <span style="width: 268px;height: 29px;font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;line-height: 48px;" class="biaotis">/ Customized R & D</span>
                </div>
                <img src="../assets/dingzhi/shengchan.png" alt="" style="margin:auto">
                <div style="margin:100px 0 40px 0">
                    <span style="width: 268px;height: 29px;font-size: 30px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;line-height: 48px;" class="biaoti">定制生产</span>
                    <span style="width: 268px;height: 29px;font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;line-height: 48px;" class="biaotis">/ Custom production</span>
                </div>
                <img src="../assets/dingzhi/yafa.png" alt="" style="margin:0 0 190px 0"> 
            </div>
        </div>
        <foot />
    </div>
</template>

<script>
import axios from 'axios';
import userLeft from '../public/user_left';
import htmlHeader from '../public/head';
import foot from '../public/foot';
export default {
    name: 'News',
    components: {
        userLeft,
        htmlHeader,
        foot
    },
    data() {
        return {
        };
    },
    methods: {
    }
};
</script>

<style scoped>
.div{
    display: table-cell;
    text-align: center;
}
.biaoti:before {
    content: '';
    width: 60px;
    height: 1px;
    border: 1px solid #2B9A34;
    display: inline-block;
    margin-right: 40px;
    margin-bottom: 10px;
}
.biaotis:after {
    content: '';
    width: 60px;
    height: 1px;
    border: 1px solid #2B9A34;
    display: inline-block;
    margin-left: 40px;
    margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/customized.vue